import { render, staticRenderFns } from "./SearchSingleResult.vue?vue&type=template&id=3fca0061&scoped=true"
import script from "./SearchSingleResult.vue?vue&type=script&lang=js"
export * from "./SearchSingleResult.vue?vue&type=script&lang=js"
import style0 from "./SearchSingleResult.vue?vue&type=style&index=0&id=3fca0061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fca0061",
  null
  
)

export default component.exports